import Immutable from 'immutable';
import { call, select } from 'redux-saga/effects';
import guid from 'uuid';
import * as documentsSelectors from 'containers/Documents/selectors';
import { referenceCitationFactory } from 'factories/document/referenceCitationFactory';
import * as Models from 'models';
import { handleSagaError } from 'services/handleError';
import { findReferenceCitationDuplicateId } from 'utils/findDocumentDuplicateId';

type Result = {
  newReferenceCitationDocument?: Models.ReferenceCitationMap;
  newReferenceCitationId?: string;
};

export function* addReferenceCitationToComponent(
  referenceCitationId: string,
): Generator<unknown, Result> {
  try {
    const storyCardDocuments = (yield select(
      documentsSelectors.storyCardsAndMagicFormsDocuments,
    )) as ReturnTypeSaga<typeof documentsSelectors.storyCardsAndMagicFormsDocuments>;
    const textCollectionsDocuments = (yield select(
      documentsSelectors.textCollectionsDocuments,
    )) as ReturnTypeSaga<typeof documentsSelectors.textCollectionsDocuments>;
    const existingReference = (storyCardDocuments.get(referenceCitationId) ||
      textCollectionsDocuments.get(referenceCitationId)) as Models.ReferenceCitationMap;

    if (!existingReference) {
      return {};
    }
    const references = (yield select(
      documentsSelectors.citationsForAssetsPanel,
    )) as ReturnTypeSaga<typeof documentsSelectors.citationsForAssetsPanel>;
    const duplicateId = findReferenceCitationDuplicateId(existingReference, references);

    if (duplicateId) {
      // use existed reference citation
      return { newReferenceCitationId: duplicateId };
    }
    // create new reference citation document in assets
    // pass the document through the factory to make sure that the document will match its interface
    const newReferenceCitationDocument = Immutable.fromJS(
      referenceCitationFactory(existingReference.set('id', guid()).toJS()),
    ) as Models.ReferenceCitationMap;

    return {
      newReferenceCitationDocument,
      newReferenceCitationId: newReferenceCitationDocument.get('id'),
    };
  } catch (error) {
    yield call(handleSagaError, error, 'ArtboardCell.addReferenceCitationToComponent', 'AddReferenceCitationToComponent');

    return {};
  }
}
